/* eslint-disable global-require */
import React from 'react';
import Article from '../../../Components/Article';
import FeaturedContentTwo from '../../../Components/FeaturedContentTwo';
import FeaturedContentCenter from '../../../Components/FeaturedContentCenter';
import Button from '../../../Components/Button';

class EducationTab extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <FeaturedContentCenter>
          <Article center>
            <header className="article__header" id="exams">
              <h2>Linguaskill for education institutions</h2>
            </header>
            <section className="article__section">
              <p>
                Testing the English language levels of students is an important activity for higher
                education institutions and pathway providers, whether for admissions, course
                placement, progress measurement or graduation.
                <br />
                Linguaskill helps institutions test candidates easily and reliably, and provides
                them with fast results. Results are aligned with the Common European Framework of
                Reference (CEFR), the international standard for describing language ability.
              </p>
            </section>
            <footer className="article__footer">
              <Button as="link" color="red" onClick={() => '#employeeBenefits'}>
                Register your interest
              </Button>
            </footer>
          </Article>
        </FeaturedContentCenter>

        <FeaturedContentTwo color="red" image={require('./image2.jpg')}>
          <Article>
            <header className="article__header">
              <h2>Fast and accurate results you can trust</h2>
            </header>
            <section className="article__section">
              <p>
                Results are generated within 48 hours, with instant results for the Reading and
                Listening module. Linguaskill has been extensively researched and trialled by
                speakers of over 40 languages from 50 countries to ensure the accuracy and
                reliability of the results.
              </p>
            </section>
          </Article>
        </FeaturedContentTwo>
        <FeaturedContentTwo right color="red" image={require('./image3.png')}>
          <Article>
            <header className="article__header" id="exams">
              <h2>Easy to administer</h2>
            </header>
            <section className="article__section">
              <p>
                The online test can be easily administered and invigilated at your own venue, at a
                time that suits you. All you need is a computer, internet connection, a microphone
                and headphones.You can test the English level of individuals or groups of
                candidates, with clear reports to compare performance.
              </p>
            </section>
          </Article>
        </FeaturedContentTwo>
        <FeaturedContentTwo color="red" image={require('./image4.jpg')}>
          <Article>
            <header className="article__header">
              <h2>
                <strong>A flexible and adaptable test for all</strong>
              </h2>
            </header>
            <section className="article__section">
              <p>
                The test is modular, so you can choose which combination of language skills is right
                for your institution. The test can be used to test candidates with varying language
                abilities, making it convenient to use within the whole institution.
              </p>
            </section>
          </Article>
        </FeaturedContentTwo>
      </React.Fragment>
    );
  }
}
export default EducationTab;
